import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { DbFolder } from '~src/types/db';
import { useFolders } from './api-hooks/useFolders';

/** returns current dbFolder, based on url id */
export const useCurrentFolder = (folders?: any) => {
  const { pathname } = useLocation();
  const { data } = useFolders(
    {
      as_admin:
        window.sessionStorage.getItem('appState') === 'superUser'
          ? true
          : undefined,
      before:
        window.sessionStorage.getItem('timeMachineDate') !== null
          ? Number(window.sessionStorage.getItem('timeMachineDate'))
          : undefined,
    },
    { enabled: false }
  );

  const parseCurrentFolder = () => {
    const paths = pathname.split('/').filter(Boolean);
    // no current folder
    if (!paths[3]) return undefined;

    // search data
    if (folders) {
      return folders?.find((v) => String(v.id) === paths[paths.length - 1]);
    }
    return data?.find((v) => String(v.id) === paths[paths.length - 1]);
  };
  const [currentFolder, setCurrentFolder] = useState<DbFolder | undefined>(
    parseCurrentFolder
  );

  useEffect(() => {
    setCurrentFolder(parseCurrentFolder);
  }, [pathname, data, folders]);

  return currentFolder;
};
